var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "permission",
          rawName: "v-permission",
          value: "SYSTEM_CONFIGURATION",
          expression: "'SYSTEM_CONFIGURATION'",
        },
      ],
      staticClass: "animated fadeIn",
    },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              attrs: {
                xs: "6",
                sm: "4",
                md: "4",
                lg: "3",
                id: "admin-menu-column",
              },
            },
            [_c("admin-menu")],
            1
          ),
          _c("b-col", { attrs: { xs: "6", sm: "8", md: "8", lg: "9" } }, [
            _c(
              "div",
              { staticClass: "tab-content" },
              [
                _c("router-view", {
                  staticClass: "animated fadeIn",
                  attrs: { header: _vm.header },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }